<template>
    <div class="form-group">
        <label>{{ label }}</label>
        <input 
            :type="displayType" 
            :value="value" 
            @input="$emit('input', $event.target.value)"
        />
        <div
            v-if="type === 'password'" 
            class="display-password" 
            @click="switchPassword"
        />
        <div v-if="errorMessage" class="error">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: String, required: true },
        label: { type: String },
        disabled: { type: Boolean, default: false },
        type: { type: String, default: 'text' },
        required: { type: Boolean, default: false },
        errorMessage: { type: String },
    },
    data: () => ({
        displayPassword: false,
    }),
    computed: {
        displayType() {
            return (this.type !== 'password') 
                ? this.type 
                : (this.displayPassword)
                    ? 'text' 
                    : 'password';
        },
    },
    methods: {
        click() {
            if (this.to) {
                this.$router.push(this.to);
            }
            this.$emit('click');
        },
        switchPassword() {
            this.displayPassword = !this.displayPassword;
        },
    },
};
</script>

<style lang="scss" scoped>
    .form-group {
        position: relative;
        padding: 16px;
        border: 1px solid #BAC5CB;
        border-radius: 4px;
        margin-bottom: 32px;
        height: 50px;
        box-sizing: border-box;

        @media screen and (max-width: 800px) {
            height: 40px;
            padding: 9px 16px;
        }

        .display-password {
            cursor: pointer;
            position: absolute;
            right: 16px;
            top: 0;
            display: block;
            width: 25px;
            background-image: url(../../assets/eye.png);
            height: 50px;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;

            @media screen and (max-width: 800px) {
                height: 40px;
            }
        }

        .error {
            display: inline-block;
            font-family: "Futura PT", sans-serif;
            font-size: 12px;
            line-height: 15px;
            color: #D1004A;
            margin-top: 16px;
        }

        label {
            font-family: "Futura PT", sans-serif;
            font-size: 12px;
            line-height: 15px;

            color: #2A2626;

            position: absolute;
            top: -8px;
            left: 12px;
            padding-left: 8px;
            padding-right: 8px;
            background-color: white;
        }
        input {
            font-family: "Futura PT";
            font-size: 16px;
            line-height: 24px;
            color: #3C3C3C;

            border:none;
            outline: none;
            height: 100%;
            width: 100%;
        }
    }
</style>